import React from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";
import { connect } from "react-redux";
import { SaveOrUpdate } from "../../../../redux/actions/catalogManagementUnitsAction";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      fieldName: this.props.history.location.state.rowData.fieldName,
      alias: this.props.history.location.state.rowData.alias,
      visible: this.props.history.location.state.rowData.visible,

      aliasRequiredAlert: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "alias") {
      this.setState({ aliasRequiredAlert: false });
    }
  }

  handleSubmit = async () => {
    $("#cover-spin").show(0);
    //
    const { actions } = this.props;

    if (this.state.visible && this.state.alias == "") {
      await this.setState({ aliasRequiredAlert: true });
    } else if (!this.state.visible && this.state.alias == "") {
      await this.setState({ aliasRequiredAlert: false });
    }

    var modelPost = {
      identification: process.env.REACT_APP_SETTING_WERKREGELS,
      code: "a34090fd-701c-4c82-876c-16257fa6eed1",
      client_identification: "a34090fd-701c-4c82-876c-16257fa6eed1",
      reference: "a3b55fd8-8d7d-4ca2-a143-39902fab3460",
      data: {
        aliases: [],
      },
    };

    var model = window.$settings_werkregels_base_Glist;

    var arrayIndex = model.data.aliases.findIndex(
      (x) => x.field_name === this.state.fieldName
    );
    model.data.aliases[arrayIndex].alias = this.state.alias;
    model.data.aliases[arrayIndex].visible = this.state.visible;

    modelPost.data.aliases = model.data.aliases;
    if (!this.state.aliasRequiredAlert && !this.state.visibleRequiredAlert) {
      omnimap
        .GetFreeFormatAction(model.identification, "PUT", modelPost)
        .then(() => {
          CallBackFunctions.BeheereenheidEditCallBack();
          this.props.history.push("/settings/werkregels/");
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      $("#cover-spin").hide(0);
    }
  };

  async componentDidMount() {
    const { actions } = this.props;
  }

  render() {
    return (
      <div id="editSide" /*className="d-none"*/>
        <div className="detail-title">werkregels in edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              id="detail-button"
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/settings/werkregels");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              werkregel
            </a>
          </div>
          <div className="float-right mt-0">
            <a onClick={this.handleSubmit.bind(this)} className="button ok">
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a
              onClick={() => {
                this.props.history.push(
                  "/settings/werkregels/detail/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
              className="button back"
            >
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div
              className="box-detail"
              style={
                this.state.aliasRequiredAlert
                  ? { border: "3px solid #e74c3c" }
                  : {}
              }
            >
              <div className="box-title-1">Alias</div>
              <div className="box-title-2">
                <input
                  id="e-algemeenCode"
                  autocomplete="off"
                  value={this.state.alias}
                  placeholder={this.state.aliasRequiredAlert ? "required" : ""}
                  name="alias"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="e-beheereenheid_active"
                  type="checkbox"
                  name="visible"
                  onChange={this.handleInputChange}
                  checked={this.state.visible ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        <input hidden id="e-identification" />
      </div>
    );
  }
}

// export default Edit;
Edit.propTypes = {
  SaveOrUpdate: PropTypes.func.isRequired,
};
function mapStateToProps(state, ownProps) {
  return {
    catalogManagementUnits: state.rowData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      SaveOrUpdate: bindActionCreators(SaveOrUpdate, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
